import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=0b77366c&scoped=true&"
import script from "./TableWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableWrapper.vue?vue&type=style&index=0&id=0b77366c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77366c",
  null
  
)

export default component.exports